// Minnesotaänger Mini App — reply bar (v1 rewrite).
// New code (not from telegram-tt). telegram-tt's version rendered reply
// quotes with sender avatars, forwarded-message info and a context menu;
// v1 shows the quoted message title + text with a cancel button.

import { memo } from '../../../lib/teact/teact';

import { getActions, withGlobal } from '../../../global';

import type { ApiMiniAppMessage } from '../../../api/miniapp/types';

import { getDisplayName } from '../../../global/helpers/displayNames';
import {
  selectMessage,
  selectReplyingToEventId,
} from '../../../global/selectors/miniapp';

import Button from '../../ui/Button';

import './ComposerEmbeddedMessage.scss';

type OwnProps = {
  chatId: string;
};

type StateProps = {
  message?: ApiMiniAppMessage;
};

function ComposerEmbeddedMessage({ message }: OwnProps & StateProps) {
  const { clearReplyingToEvent } = getActions();

  if (!message) return undefined;

  const title = message.role === 'user' ? '你' : getDisplayName(message.assistant_id ?? '');

  return (
    <div className="ComposerEmbeddedMessage open">
      <div className="ComposerEmbeddedMessage_inner">
        <span className="embedded-left-icon"><i className="icon icon-reply" /></span>
        <div className="inside-input">
          <span className="embedded-title">{title}</span>
          <span className="embedded-message-text">{message.text}</span>
        </div>
        <Button
          className="embedded-cancel"
          color="translucent"
          round
          ariaLabel="取消回复"
          onClick={() => clearReplyingToEvent()}
        >
          <i className="icon icon-close" />
        </Button>
      </div>
    </div>
  );
}

export default memo(withGlobal<OwnProps>((global, { chatId }): StateProps => {
  // v1 (fix-list E): reply target is an event_id — no Number() conversion.
  const replyToEventId = selectReplyingToEventId(global, chatId);
  return {
    message: replyToEventId ? selectMessage(global, chatId, replyToEventId) : undefined,
  };
})(ComposerEmbeddedMessage));
